module.exports = __webpack_public_path__ + "static/media/banner_slider4.071c32a8.jpg";